(function () {
  if (window.__fhFaqReady) return;
  window.__fhFaqReady = true;

  function inner(details) {
    return details.querySelector('[data-faq-content]');
  }

  function height(content) {
    var kid = content.firstElementChild;
    return kid ? kid.getBoundingClientRect().height : 0;
  }

  function reduced() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function expand(details) {
    var content = inner(details);
    if (!content) { details.open = true; return; }
    details.open = true;
    if (reduced()) { content.style.height = 'auto'; return; }
    content.style.height = '0px';
    void content.offsetHeight;
    content.style.height = height(content) + 'px';
    var done = function (e) {
      if (e.propertyName !== 'height') return;
      content.removeEventListener('transitionend', done);
      if (details.open) content.style.height = 'auto';
    };
    content.addEventListener('transitionend', done);
  }

  function collapse(details) {
    var content = inner(details);
    if (!content) { details.open = false; return; }
    if (reduced()) { details.open = false; content.style.height = ''; return; }
    content.style.height = height(content) + 'px';
    void content.offsetHeight;
    content.style.height = '0px';
    var done = function (e) {
      if (e.propertyName !== 'height') return;
      content.removeEventListener('transitionend', done);
      details.open = false;
      content.style.height = '';
    };
    content.addEventListener('transitionend', done);
  }

  document.addEventListener('click', function (e) {
    var summary = e.target.closest ? e.target.closest('[data-faq-summary]') : null;
    if (!summary) return;
    var card = summary.closest('[data-faq-card]');
    if (!card) return;
    var details = summary.parentElement;
    e.preventDefault();

    if (details.open) {
      collapse(details);
      return;
    }
    if (card.dataset.faqSingle !== 'false') {
      card.querySelectorAll('[data-faq-details]').forEach(function (other) {
        if (other !== details && other.open) collapse(other);
      });
    }
    expand(details);
  });

  window.addEventListener('resize', function () {
    document.querySelectorAll('[data-faq-card] [data-faq-details][open]').forEach(function (d) {
      var content = inner(d);
      if (content && content.style.height && content.style.height !== 'auto') {
        content.style.height = height(content) + 'px';
      }
    });
  });
})();
